// extracted by mini-css-extract-plugin
export default {"btnRelatorio":"RelatoriosPageStyle_btnRelatorio__J+yji"};